/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const parseExtensionId = (
	extensionId: string,
): {
	appId: string;
	envId: string;
} => {
	const [, appId, envId] = extensionId.split('/');
	return {
		appId,
		envId,
	};
};

export const getSameEnvAppIdFromExtensionId = (extensionId: string): string =>
	extensionId.split('/').slice(1, 3).join('/');
